import { commonEnv } from 'src/environments/environment.common';
import { Environment } from '../types';

const env: Partial<Environment> = {
    production: false,
    environment: 'develop',
    googleMapApiKey: 'AIzaSyDEj2fA_3Jnhs8s1XsMFSwQ-iNq1py21Ik',
    addressValidationApiKey: 'AIzaSyDOf0PpZxijedoSq90JUadLJpVIn4NNJek',
    projects: {
        sprintPay: 'https://qa.sprintpay.cargosprint.com',
        polar: 'https://polar-stng.web.app',
    },
    authenticationURL: 'https://auth-develop.cargosprintgroup.com',
    appSentryDsn: 'https://99ee8b8ede8bc8175c381a6730090b46@o4507493303582720.ingest.us.sentry.io/4507931302100992',
    googleMapIdDark: 'e7d483ab572493f1',
    googleMapIdLight: 'b92df4332bcf4b88',
    statsigSdkKey: 'client-TMqqFjGeGc0kG9eRXJ6v4lOagxLOSuBdNvCfH6RjsO1',
    keycloakConfig: {
        url: 'https://sso-qa.cargosprint.com',
        realm: 'unified-portal-new',
        clientId: 'test-ui',
    },
    applicationName: 'dhl',
};

export const environment = Object.assign(commonEnv, env);
